<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">
				NAKLİYE TEKLİF FORMU
			</h3>
		</div>
	</div>
	<div class="kt-portlet__body">
		<div class="alert alert-info fade show text-center offerForm" role="alert">
			<div class="alert-icon"><i class="flaticon2-check-mark"></i></div>
			<div class="alert-text">TKF00007 No'lu teklifiniz onaylanmıştır. Lütfen aşağıdaki formu doldurun.</div>
		</div>
		<div class="kt-form kt-form--label-right offerForm">

			<div class="form-group row">
				<label class="col-lg-3 offset-lg-3 col-form-label">Araç Plaka</label>
				<div class="col-lg-2">
					<input type="text" class="form-control" placeholder="Plaka">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-lg-3 offset-lg-3 col-form-label">Şoför Adı</label>
				<div class="col-lg-2">
					<input type="text" class="form-control" placeholder="Ad Soyad">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-lg-3 offset-lg-3 col-form-label">Şoför Telefon</label>
				<div class="col-lg-2">
					<input class="form-control"
						   #input
						   type="text"
						   maxlength="14"
						   placeholder="(5xx)-xxx-xxxx"
						   [(ngModel)]="selectedPhoneNumber"
						   name="phoneNumber"
						   #phoneNumber="ngModel"
						   (change)="onChangePhoneNumber()"
						   (keyup)="onKeyupPhoneMask()"
						   required>
				</div>
			</div>
			<div class="form-group row">
				<div class="col-lg-4 offset-lg-4 text-center">
					<button class="btn btn-success btn-block">Kaydet</button>
				</div>
			</div>
		</div>

	</div>
</div>
<!--<div class="col-md-12 kt-margin-bottom-10-mobile">
			<label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
				<input type="checkbox" name="checkbox1">

				<span></span>
			</label>
		</div>-->
